import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { Loader2, Briefcase } from 'lucide-react';
import { Progress } from '@/components/ui/progress';
import { useAuth } from '@/context/AuthContext';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const MISSION_STATUTS = {
    en_cours: { label: 'En cours', cls: 'bg-emerald-50 text-emerald-700 border-emerald-200' },
    cloturee: { label: 'Clôturée', cls: 'bg-stone-100 text-stone-600 border-stone-200' },
};

export default function AdrnsMissions() {
    const { session } = useAuth();
    const [items, setItems] = useState(null);
    const [filter, setFilter] = useState('en_cours');

    useEffect(() => {
        if (!session) return;
        axios.get(`${API}/adrns/missions`, { headers: { Authorization: `Bearer ${session.access_token}` } })
            .then(r => setItems(r.data.items)).catch(() => setItems([]));
    }, [session]);

    if (!items) return <div className="flex justify-center py-20"><Loader2 className="animate-spin" /></div>;
    const shown = items.filter(m => filter === 'toutes' || m.statut === filter);

    return (
        <div className="space-y-6" data-testid="adrns-missions-page">
            <div>
                <div className="eyebrow mb-2">ADRNS · Module 7 transversal</div>
                <h1 className="font-heading text-4xl">Missions d'accompagnement</h1>
                <p className="text-sm text-foreground/60 mt-2">Le cabinet de conseil numérique : chaque mission orchestre les modules, les livrables, les réunions et l'historique avec une méthodologie homogène.</p>
            </div>
            <div className="flex gap-2">
                {[['en_cours', 'En cours'], ['cloturee', 'Clôturées'], ['toutes', 'Toutes']].map(([k, l]) => (
                    <button key={k} onClick={() => setFilter(k)}
                        className={`px-3 py-1.5 rounded-full border text-sm ${filter === k ? 'bg-primary text-primary-foreground border-primary' : 'border-border'}`}
                        data-testid={`missions-filter-${k}`}>{l}</button>
                ))}
            </div>
            {shown.length === 0 ? (
                <div className="card-soft p-12 text-center text-foreground/60" data-testid="missions-empty">
                    <Briefcase size={30} className="mx-auto mb-3 text-muted-foreground" />
                    Aucune mission. Ouvrez une mission depuis un dossier d'accompagnement.
                </div>
            ) : (
                <div className="space-y-3">
                    {shown.map(m => (
                        <Link key={m.id} to={`/app/adrns/dossiers/${m.dossier_id}/missions/${m.id}`}
                            className="card-soft p-4 flex items-center gap-4 hover:border-primary/40 transition-colors block"
                            data-testid={`mission-row-${m.id}`}>
                            <Briefcase size={18} className="text-primary shrink-0" />
                            <div className="flex-1 min-w-0">
                                <div className="font-medium truncate">{m.titre}</div>
                                <div className="text-xs text-muted-foreground">{m.type_nom} · {m.porteur_name} · {m.livrables_valides}/{m.livrables_total} livrables validés</div>
                            </div>
                            <div className="w-40 hidden sm:block"><Progress value={m.avancement} className="h-1.5" /></div>
                            <span className="text-sm font-medium w-10 text-right">{m.avancement}%</span>
                            <span className={`text-[10px] px-2 py-0.5 rounded-full border font-medium ${(MISSION_STATUTS[m.statut] || {}).cls}`}>
                                {(MISSION_STATUTS[m.statut] || {}).label || m.statut}
                            </span>
                        </Link>
                    ))}
                </div>
            )}
        </div>
    );
}
